import { KnownBackendApiError } from '@/lib/api/exception.ts';

/** Nazwa adnotacji walidacyjnej Beana, którą backend odsyła przy ujemnej kwocie. */
const POSITIVE_OR_ZERO = 'PositiveOrZero';

export type TourBudgetAmountField = 'fixedAmount' | 'perParticipantAmount';

/**
 * Ujemna kwota wraca jako błąd pola, nie jako komunikat ogólny — pokazujemy go
 * pod polem, zamiast zostawiać operatora z samym toastem.
 */
export const getNegativeAmountField = (
  error: unknown,
): TourBudgetAmountField | undefined => {
  if (!(error instanceof KnownBackendApiError)) return undefined;

  const fields = Object.values(error.getApiErrorDto())
    .filter((single) => single.errorName === POSITIVE_OR_ZERO)
    .map((single) => single.fieldName);

  if (fields.includes('fixedAmount')) return 'fixedAmount';
  if (fields.includes('perParticipantAmount')) return 'perParticipantAmount';
  return undefined;
};
